import React from "react";
import { Box } from "@mui/material";
import documentIcon from "../../assets/document-icon.png";

interface Props {
  title?: string;
  extension?: string;
}

export const DocumentIcon = ({ title, extension }: Props): JSX.Element => {
  return (
    <Box style={{ width: "120px", position: "relative" }}>
      <img
        style={{ display: "flex", maxWidth: "100%", maxHeight: "100%" }}
        src={documentIcon}
        alt={title}
        title={title}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "9px",
          right: "20px",
          color: "white",
          fontWeight: 800,
          fontSize: 20,
          width: "50px",
        }}
      >
        {extension}
      </Box>
    </Box>
  );
};
